import { render, staticRenderFns } from "./TimeslotsPage.vue?vue&type=template&id=63d94caf&scoped=true&"
import script from "./TimeslotsPage.vue?vue&type=script&lang=js&"
export * from "./TimeslotsPage.vue?vue&type=script&lang=js&"
import style0 from "./TimeslotsPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TimeslotsPage.vue?vue&type=style&index=1&id=63d94caf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d94caf",
  null
  
)

export default component.exports